import { utils, WorkSheet } from 'xlsx';
import { ModelSettings } from './types';

export const useXlsxValidation = (currentModelSettings: ModelSettings) => {
  const validFileExtensions: { [key: string]: string[] } = {
    file: currentModelSettings.allowedFileTypes,
  };

  const sheetsRequired = currentModelSettings.sheets || [];

  /*
  Validate file by type
   */
  const isValidFileType = (fileName: string, fileType: string): boolean => {
    const ext = fileName?.split('.')?.pop();
    if (!fileName || !ext) return false;
    return validFileExtensions[fileType].indexOf(ext) > -1;
  };

  const compareDataWithRequiredColumns = (
    currentColumns: any[], // columns from file
    initialColumns: any[], // columns from settings
  ): boolean => {
    if (!initialColumns || !currentColumns.length) return false;
    const sortedInitialColumns = [...initialColumns].sort();
    const sortedCurrentColumns = [...currentColumns].sort();

    return sortedInitialColumns.every((value) => {
      if (typeof value === 'string') {
        return sortedCurrentColumns.includes(value);
      } else {
        return value.some((el: string) => sortedCurrentColumns.includes(el));
      }
    });
  };

  const detectRowToValidate = (rawData: any[], sheets: any[]) => {
    let isValid;
    let rowToValidate = 0;
    rawData.slice(0, 15).forEach((el, index) => {
      isValid = compareDataWithRequiredColumns(el, sheets);
      if (isValid) {
        rowToValidate = index;
      }
      isValid = false;
    });

    return rowToValidate;
  };

  /*
  Validate list of files contains required sheets
   */
  // const isContainsRequiredSheets = (list: string[]) => {
  //   let sheetsFound = 0;
  //   if (sheetsRequired.length === 0) {
  //     return true;
  //   } else {
  //     const uniqueList = list.filter(
  //       (value, index) => list.indexOf(value) === index,
  //     );
  //
  //     uniqueList.forEach((sheet: any) => {
  //       if (
  //         !!sheetsRequired.filter((el: any) =>
  //           typeof sheet === 'string'
  //             ? el.name === sheet
  //             : sheet.includes(el.name),
  //         ).length
  //       ) {
  //         sheetsFound++;
  //       }
  //     });
  //   }
  //   return sheetsFound === sheetsRequired.length;
  // };

  /*
  Validate list of files contains required sheets
*/
  const isContainsRequiredSheets = (list: string[]) => {
    if (sheetsRequired.length === 0) {
      return true;
    }

    const uniqueList = Array.from(new Set(list));

    return sheetsRequired.every((requiredSheet: any) =>
      uniqueList.some((sheet: any) =>
        typeof requiredSheet.name === 'string'
          ? requiredSheet.name === sheet
          : requiredSheet.name.includes(sheet),
      ),
    );
  };

  const isSheetContentValid = (list: any) => {
    let isValid: boolean[] = [];
    let rowToValidate: number;

    if (list.length === 0) return false;

    if (list.length === 1) {
      Object.entries(list[0]).forEach((sheet: WorkSheet) => {
        if (sheetsRequired.filter((el: any) => el.name === sheet[0]).length) {
          const raw_data: any[] = utils.sheet_to_json(sheet[1], { header: 1 });
          if (!rowToValidate) {
            rowToValidate = detectRowToValidate(
              raw_data,
              sheetsRequired.filter((el: any) => el.name === sheet[0])[0]
                ?.columns,
            );
          }
          isValid.push(
            compareDataWithRequiredColumns(
              raw_data[rowToValidate],
              sheetsRequired.filter((el: any) => el.name === sheet[0])[0]
                ?.columns,
            ),
          );
        }
      });
    } else {
      list.forEach((item: { [s: string]: unknown } | ArrayLike<unknown>) => {
        Object.entries(item).forEach((sheet: WorkSheet) => {
          if (sheetsRequired.filter((el: any) => el.name === sheet[0]).length) {
            const raw_data: any[] = utils.sheet_to_json(sheet[1], {
              header: 1,
            });
            if (!rowToValidate) {
              rowToValidate = detectRowToValidate(
                raw_data,
                sheetsRequired.filter((el: any) => el.name === sheet[0])[0]
                  ?.columns,
              );
            }
            isValid.push(
              compareDataWithRequiredColumns(
                raw_data[rowToValidate],
                sheetsRequired.filter((el: any) => el.name === sheet[0])[0]
                  ?.columns,
              ),
            );
          }
        });
      });
    }

    return !isValid.includes(false);
  };

  return { isValidFileType, isContainsRequiredSheets, isSheetContentValid };
};
